import classNames from 'classnames';
import { autobind } from 'core-decorators';
import { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import settings from '/@/core/settings';
import { withRouter } from '/@/hooks/with-router';
import { _ } from '/@/locale';
import { editProfile, signUp, socialSignUp } from '/@/store/session/actions';
import { getAppInstance, getUser } from '/@/store/session/selectors';
import { validatePassword } from '/@/utils';
import { validatePhoneNumber } from '/@/utils/phone-numbers';
import { encodeNextUrl } from '/@/utils/router';
// V3 components
import Title from '/@/v3/components/title';
import UserForm from '/@/views/users/user-form';
import styles from './styles.module.css';

@withRouter
@connect(
    (state) => ({
        user: { ...getUser(state) },
        appInstance: getAppInstance(state),
    }),
    (dispatch) => bindActionCreators({ signUp, socialSignUp, editProfile }, dispatch)
)
@autobind
export default class NewUser extends Component {
    state = {
        showWelcome: false,
        showTerms: false,
    };

    handleSubmit(values) {
        const handler = this.props.social ? this.props.socialSignUp : this.props.signUp;

        return handler({
            ...values,
        });
    }

    handleSubmitAfterWelcome(values) {
        return this.props.editProfile({
            ...values,
        });
    }

    showWelcome() {
        this.setState({ showWelcome: true });
        this.props.nextBtn();
    }

    renderTitle() {
        if (this.state.showTerms) {
            return _('Términos y condiciones');
        }
        if (this.props.password) {
            return _('Ya casi estás!');
        }
        if (this.state.showWelcome) return `${_('Gracias')} ${this.props.user.first_name} ${_('por Unirte!')}`;
        return _('Hola!');
    }

    renderDescription() {
        if (this.state.showTerms) {
            return this.props.appInstance.termsAndConditions[this.props.appInstance.language];
        }
        if (this.props.password) {
            return _('Podrás recibir mensajes y consejos del equipo {{appName}} al E-mail que ingreses.', {
                appName: settings.app.name,
            });
        }
        if (this.state.showWelcome) {
            return _(
                'El equipo Cultivio te da la bienvenida,  y te agradece por formar parte de Nuestra plataforma. Trabajamos dia a dia para ofrecerte la mejor experiencia.'
            );
        }
        return _('En solo 3 pasos vas a poder acceder a nuestra plataforma. Contanos un poco sobre vos.');
    }

    goBack() {
        if (this.state.showTerms) {
            this.setState({ showTerms: false });
        } else if (this.props.password && !this.state.showWelcome) {
            this.props.goBack();
        } else if (this.state.showWelcome) {
            this.props.goBackToPassword();
        } else {
            this.props.onClick();
        }
    }

    render() {
        const fields = {
            terms: { initial: false },
            privacyPolicy: { initial: false },
            password: { initial: '', required: !this.props.social },
            confirmPassword: { initial: '', required: !this.props.social },
        };

        const validation = {
            confirmPassword: (values) => {
                if (this.props.social) return true;
                return validatePassword(values.confirmPassword, values.password);
            },
            phone: (values) => {
                if (!validatePhoneNumber(values.phone)) return _('El formato del número de teléfono es incorrecto.');
                return true;
            },
        };

        return (
            <div className={`${styles.container} mp-mask`}>
                <div className={styles.header}>
                    <span
                        id={!this.state.showWelcome ? styles.icon : styles.hidden}
                        onClick={this.goBack}
                        className='material-icons'
                    >
                        arrow_back
                    </span>

                    <div className={classNames(styles.logo, styles[`theme-${settings.app.theme}`])} />
                </div>
                <div className={styles.formContainer}>
                    <div className={styles.formContent}>
                        <Title
                            className={styles.title}
                            size='xl'
                            align='left'
                            color='primary'
                            theme={settings.app.theme}
                        >
                            {this.renderTitle()}
                        </Title>
                        <Title
                            size='md'
                            align='left'
                            className={classNames(styles.description, this.state.showTerms && styles.termsContainer)}
                        >
                            {this.renderDescription()}
                        </Title>

                        <div className={classNames(styles.form, this.state.showTerms && styles.hide)}>
                            <UserForm
                                user={this.props.user}
                                fields={fields}
                                nextUrl={encodeNextUrl(this.props.location)}
                                onSubmit={this.handleSubmit}
                                validation={validation}
                                enforceReceiveNotifications
                                enforceReceiveWhatsappNotifications
                                notifications={this.state.showWelcome && !this.props.password}
                                login={this.props.login}
                                password={this.props.password}
                                changeToWelcomeView={() => this.showWelcome()}
                                showWelcome={this.state.showWelcome}
                                nextBtn={this.props.nextBtn}
                                loginView
                                onClickTerms={() => this.setState({ showTerms: true })}
                                onSubmitAfterWelcome={this.handleSubmitAfterWelcome}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
